import {Component,Inject,OnInit} from '@angular/core';
import {ListView} from "@domain/common/list-view";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialog as MatDialog,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {TranslateService} from "@ngx-translate/core";
import {TypeBareme} from "@domain/prestation/TypeBareme";
import {Bareme} from "@domain/prestation/bareme";
import {BaremeListItemComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/bareme-list-item.component";
import {Result} from "@domain/common/http/result";
import {BaremeDetailPopinComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/bareme-detail-popin.component";
import {NiveauAlerte} from "@domain/common/alerte/alerte";
import {PrestationService} from "@services/admin/frais/prestation.service";

/**
 * Popin des barèmes
 */
@Component({
	host: {'data-test-id': 'bareme-popin'},
	templateUrl: './bareme-popin.component.html',
	styles: [
		'::ng-deep .mat-dialog-without-margin .mat-dialog-container { padding: 0 }',
		'::ng-deep .mat-dialog-without-margin .mat-card { margin-bottom: 0 }'
	]
})
export class BaremePopinComponent implements OnInit {
	/** Liste des barèmes */
	listeBareme: ListView<Bareme,BaremeListItemComponent>;

	/**
	 * Constructeur
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { idPrestation: number, typeBareme: TypeBareme, unite: string },
		private translateService: TranslateService,
		private prestationService: PrestationService,
		private matDialogRef: MatDialogRef<BaremePopinComponent>,
		private matDialog: MatDialog
	) {}

	/**
	 * Initialisation du composant
	 */
	ngOnInit(): void {
		//Initialisation de la liste
		this.listeBareme = new ListView<Bareme,BaremeListItemComponent>({
			uri: `/controller/AdminPrestation/listeBareme${this.data.typeBareme == TypeBareme.BAREME_SNCF ? 'SNCF' : '' }/${this.data.idPrestation}`,
			title: this.translateService.instant(`admin.frais.prestations.detail.reglesGestion.remboursement.bareme.${this.data.typeBareme == TypeBareme.BAREME_SNCF ? 'sncf' : 'fiscal'}`),
			component: BaremeListItemComponent,
			isSimple: true,
			maxScrollableHeight: '70vh',
			mapResult: (result: Result) => result?.data?.listeBareme as Bareme[],
			extraOptions: {
				typeBareme: this.data.typeBareme,
				unite: this.data.unite
			},
			listeActions: [
				{
					icon: 'add',
					onPress: () => this.createBareme()
				},{
					icon: 'close',
					onPress: () => this.matDialogRef.close(true)
				}
			]
		});

		//Si le type de barème est SNCF
		if (this.data.typeBareme == TypeBareme.BAREME_SNCF) {
			//Ajout de l'alerte
			this.listeBareme.alerte = {
				niveau: NiveauAlerte.PROFIL_USER,
				message: this.translateService.instant('admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.alerteSNCF')
			};
		}
	}

	/**
	 * Création d'un barème
	 */
	createBareme(): void {
		//Initialisation du barème
		const bareme = new Bareme();

		//Valeurs par défaut
		bareme.idPrestation = this.data.idPrestation;
		bareme.dateAppli = this.listeBareme?.data?.listeResultats[0]?.dateAppli;

		//Ouverture de la popin de consultation/modification
		this.matDialog.open(BaremeDetailPopinComponent,{
			data: {
				bareme: bareme,
				typeBareme: this.data.typeBareme,
				unite: this.data.unite,
				mapLastBaremeByDate: this.prestationService.mapLastBaremeByDate(this.listeBareme?.data?.listeResultats ?? [])
			},
			width: '65%',
		}).afterClosed().subscribe((refresh: boolean) => {
			if (refresh) {
				//Rafraîchissement de la liste
				this.listeBareme.refresh();
			}
		})
	}
}